module.exports = __webpack_public_path__ + "img/arrow-right.0256bf4d.svg";